<template>
  <svg
    width="24"
    height="25"
    viewBox="0 0 24 25"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M18 11.268C19.3333 12.0378 19.3333 13.9623 18 14.7321L10.5 19.0622C9.16666 19.832 7.5 18.8697 7.5 17.3301L7.5 8.66987C7.5 7.13027 9.16667 6.16802 10.5 6.93782L18 11.268Z"
      fill="#888888"
    />
  </svg>
</template>
